import { cliSimpleGit } from '../cli-simple-git.js';

export async function gitCommitAllIfDirty(
  repoDir: string,
  message: string,
  options: { push: boolean; branch: string }
): Promise<void> {
  const g = cliSimpleGit(repoDir);
  const st = await g.status();
  if (!st.files?.length) return;

  const branch = options.branch.trim();
  if (!branch) {
    throw new Error('Branch name is required');
  }

  const branches = await g.branchLocal();
  const localNames = new Set(branches.all.map((b) => b.replace(/^\*\s*/, '').trim()));
  if (!localNames.has(branch)) {
    await g.checkoutLocalBranch(branch);
  } else {
    await g.checkout(branch);
  }

  await g.add('.');
  await g.commit(message);
  if (options.push) {
    await g.push(['-u', 'origin', branch]);
  }
}
